import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left gap-4" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-black font-inter text-base font-semibold normal-case leading-6" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex flex-col"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              innerHTML: feature.icon,
              class: "text-primary-purple w-6 h-6"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(feature.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            href: _ctx.meetingUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createElementVNode("img", {
              src: feature.image,
              alt: feature.title,
              class: "w-full md:w-2/3 cursor-pointer"
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7)
        ])
      ]))
    }), 128))
  ]))
}